import { WaybillAttachments } from './components/attachments';
import { WaybillsFromExcel } from './components/create-from-excel';
import { WaybillForm } from './components/form';
import { LotForm } from './components/lot/index';
import { AttachLotForm } from './components/attach-existing';
import { Waybills } from './components/table';

import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_WAYBILL,
  PERMISSION_OBJ_WAYBILL_WEIGHING_ANALYSIS,
  PERMISSION_OBJ_FARMER,
  PERMISSION_OBJ_LOT,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';
import { WaybillView } from './components/view';
import { ProductForm } from './components/product';
import { FactoryForm } from './components/factory';
import { WaybillWeighingAnalysesFromExcel } from './components/add-lab-analyses-from-excel';
import { LinkWaybillWithFarmersFromExcel } from './components/link-with-farmers-from-excel';

export const states = [
  {
    name: 'base-layout.waybills',
    url: '/waybills?productName&consortiumName&weighingAnalysisStartDate&weighingAnalysisEndDate&missingCooperativeConsortium',
    params: {
      productName: { dynamic: true, value: null, squash: true },
      consortiumName: { dynamic: true, value: null, squash: true },
      weighingAnalysisStartDate: { dynamic: true, value: null, squash: true },
      weighingAnalysisEndDate: { dynamic: true, value: null, squash: true },
      missingCooperativeConsortium: { dynamic: true, value: null, squash: true },
    },
    component: Waybills,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.waybills.create',
    url: '/new',
    component: WaybillForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.waybills.edit',
    url: '/:waybillId/edit',
    component: WaybillForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.waybills.lot',
    url: '/:waybillId/lot',
    component: LotForm,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_LOT, PERMISSION_CREATE],
        [PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE],
      ],
    },
  },
  {
    name: 'base-layout.waybills.attach-lot',
    url: '/:waybillId/attach-lot',
    component: AttachLotForm,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_LOT, PERMISSION_UPDATE],
        [PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE],
      ],
    },
  },
  {
    name: 'base-layout.waybills.create-from-excel',
    url: '/create-from-excel',
    component: WaybillsFromExcel,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.waybills.add-lab-analyses-from-excel',
    url: '/add-lab-analyses-from-excel',
    component: WaybillWeighingAnalysesFromExcel,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_WAYBILL, PERMISSION_CREATE],
        [PERMISSION_OBJ_WAYBILL_WEIGHING_ANALYSIS, PERMISSION_CREATE],
      ],
    },
  },
  {
    name: 'base-layout.waybills.attachments',
    url: '/:waybillId/attachments',
    component: WaybillAttachments,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.waybills.view',
    url: '/:waybillId/view',
    component: WaybillView,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_READ]],
    },
  },
  // {
  //   name: "base-layout.waybills.analysis",
  //   url: "/:waybillId/analysis",
  //   component: AnalysisForm,
  //   data: {
  //     requiresAuth: true,
  //     permissions: [[PERMISSION_OBJ_WAYBILL_WEIGHING_ANALYSIS, PERMISSION_CREATE]],
  //   },
  // },
  {
    name: 'base-layout.waybills.mass-add-product',
    url: '/mass-add-product',
    component: ProductForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.waybills.mass-add-factory',
    url: '/mass-add-factory',
    component: FactoryForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_WAYBILL, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.waybills.link-with-farmers-from-excel',
    url: '/link-with-farmers-from-excel',
    component: LinkWaybillWithFarmersFromExcel,
    data: {
      requiresAuth: true,
      permissions: [
        [PERMISSION_OBJ_WAYBILL, PERMISSION_CREATE],
        [PERMISSION_OBJ_FARMER, PERMISSION_CREATE],
      ],
    },
  },
];
